import { SectionContainerStyled } from 'components/atoms/container/index.styled'
import { IExpertInfo } from 'interfaces/categories.interface'
import Link from 'next/link'
import styled from 'styled-components'

const ExpertAvatarStyled = styled(SectionContainerStyled)`
  text-align: center;
  .avatar-icon {
    position: relative;
    display: inline-block;
    border: 8px solid ${(props) => props.theme.colors.white};
    background: ${(props) => props.theme.colors.white};
    border-radius: 999px;
  }
  .badge-avatar {
    position: absolute;
    right: -8px;
    bottom: 8px;
    border: 2px solid ${(props) => props.theme.colors.white};
    background: ${(props) => props.theme.colors.white};
    border-radius: 99px;
  }
  .socials {
    display: flex;
    justify-content: center;
    .social {
      margin: 0 4px;
    }
  }
  .social-icon {
    width: 24px;
    height: 24px;
  }
  .expert-info {
    position: relative;
    p,
    h1 {
      padding: 4px 0;
    }
    .name {
      font-size: 18px;
      font-weight: 600;
    }
  }
  .expert-avatar {
    border-radius: 999px;
    object-fit: cover;
  }
`

const ExpertInfo = ({
  role,
  urlImg,
  name,
  major,
  organisationUrl,
  contact: _contact,
}: IExpertInfo) => {
  const contactKeys = Object.keys(_contact).filter(
    (key: string) => key !== 'url' && !!_contact?.['url'],
  )

  const isAcceptRole = ['author', 'editor', 'expert', 'medical'].includes(
    role as string,
  )

  return (
    <ExpertAvatarStyled>
      <a
        className="avatar-icon"
        data-event-category="Social Share"
        data-event-action={role}
        data-event-label={organisationUrl}
        target="_blank"
        href={organisationUrl}
      >
        <img
          loading="lazy"
          style={{ width: 72, height: 72 }}
          className="expert-avatar"
          width={72}
          height={72}
          src={urlImg || '/images/bookDoctor.svg'}
          alt={'avatar'}
        />
        {isAcceptRole && (
          <img
            loading="lazy"
            className="badge-avatar social-icon"
            src={`/svg/experts/${role}-role.svg`}
            alt="badge"
          />
        )}
      </a>
      <SectionContainerStyled className="expert-info">
        <h1 className="name">{name}</h1>
        {!!major && <p className="major">{major}</p>}
        <p className="socials">
          {contactKeys.map((contactKey) => (
            <Link key={contactKey} href="/">
              <img
                loading="lazy"
                className="social social-icon"
                src={`/svg/${contactKey}.svg`}
                alt="social"
              />
            </Link>
          ))}
        </p>
      </SectionContainerStyled>
    </ExpertAvatarStyled>
  )
}

export default ExpertInfo
